import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {Button, Col, Form, Input, notification, Row} from 'antd';
import {DefaultLayout} from "../../layouts";
import {Authentication, ShowValidationErrorNotification} from '../../utils';
import QueryString from 'query-string';
import Container from "../../components/Container";
import ShowErrorNotification from "../../utils/error/ShowErrorNotification";

class ResetPasswordPage extends Component {
    state = {};

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleConfirmBlur = this.handleConfirmBlur.bind(this);
        this.compareToFirstPassword = this.compareToFirstPassword.bind(this);
        this.validateToNextPassword = this.validateToNextPassword.bind(this);
        this.resend = this.resend.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return notification.error({
                    message: 'Kullanıcı kaydı yapılamadı',
                    description: 'Lütfen eksik veya hatalı bilgileri kontrol edip tekrar deneyin.'
                });
            }
            console.log('Received values of form: ', values);
            const {email, code, password} = values;
            this.setState({submitting: true});
            Authentication.resetPassword(email, code, password)
                .then(success => {
                    console.log('Success', success);
                    notification.success({
                        message: 'Kullanıcı kaydı gönderildi',
                        description: 'Emailinizi kontrol edip yönergelere göre onay sürecini tamamlayın.'
                    });
                    this.props.history.push('/login');
                })
                .catch(err => ShowErrorNotification('Şifre sıfırlanamadı', err))
                .finally(() => this.setState({submitting: false}));
        });
    };

    resend() {
        this.props.form.validateFieldsAndScroll(['email'], (err, values) => {
            if (err) {
                return ShowValidationErrorNotification(err);
            }
            const {email} = values;
            this.setState({resending: true});
            Authentication.forgotPassword(email)
                .then(success => {
                    notification.success({
                        message: 'Email tekrar gönderildi',
                        description: 'Emailinizi kontrol edip yönergelere göre onay sürecini tamamlayın.'
                    });
                })
                .catch(err => ShowErrorNotification('Email tekrar gönderilemedi', err))
                .finally(() => this.setState({resending: false}));
        });
    }

    handleConfirmBlur(e) {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    compareToFirstPassword(rule, value, callback) {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Girilen şifreler aynı değil');
        } else {
            callback();
        }
    };

    validateToNextPassword(rule, value, callback) {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    };

    render() {
        const {email, code} = QueryString.parse(this.props.location.search);
        const {getFieldDecorator} = this.props.form;
        return (
            <DefaultLayout>
                <Container size="small">
                    <div className="page">
                        <h1 className="page-header">Şifremi Unuttum</h1>
                        <Form onSubmit={this.handleSubmit}>
                            <Row gutter={24}>
                                <Col>
                                    <Form.Item label="Email Adresi">
                                        {getFieldDecorator('email', {
                                            initialValue: email,
                                            rules: [
                                                {required: true, message: 'Email adresi girilmemiş'},
                                                {type: 'email', message: 'Geçerli bir email adresi değil'}
                                            ]
                                        })(<Input disabled={email !== undefined} />)}
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Kod">
                                        {getFieldDecorator('code', {
                                            initialValue: code,
                                            rules: [{required: true, message: 'Kod girilmemiş'}]
                                        })(<Input disabled={code !== undefined} autoFocus={code === undefined}/>)}
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Yeni Şifre">
                                        {getFieldDecorator('password', {
                                            rules: [
                                                {required: true, message: 'Şifre girilmemiş'},
                                                {validator: this.validateToNextPassword}
                                            ],
                                        })(<Input.Password autoFocus={code !== undefined} />)}
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Yeni Şifre (tekrar)">
                                        {getFieldDecorator('confirm', {
                                            rules: [
                                                {required: true, message: 'Şifre tekrar girilmemiş'},
                                                {validator: this.compareToFirstPassword}
                                            ],
                                        })(<Input.Password onBlur={this.handleConfirmBlur} />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <br/>
                            <Row type="flex" gutter={[16,16]}>
                                <Col>
                                    <Button
                                        loading={this.state.submitting}
                                        type="primary"
                                        htmlType="submit"
                                        icon="check"
                                    >
                                        Şifremi Sıfırla
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        loading={this.state.resending}
                                        icon="mail"
                                        onClick={this.resend}
                                    >
                                        Yeniden Gönder
                                    </Button>
                                </Col>
                            </Row>

                        </Form>
                    </div>
                </Container>
            </DefaultLayout>
        );
    }
}

export default Form.create()(withRouter(ResetPasswordPage));
